import type { PasswordRequirementFeedback as PasswordFeedbackModel } from "../../auth/passwordPolicy";

type Props = {
  feedback: PasswordFeedbackModel;
};

/** Bullets + strength line used under every “new password” field (register, reset, etc.). */
export default function PasswordRequirementFeedback({ feedback }: Props) {
  return (
    <div className="auth-flow-password-feedback small mt-2 mb-0">
      {feedback.intro ? <p className={`mb-1 fw-semibold ${feedback.className}`}>{feedback.intro}</p> : null}
      {feedback.strengthLabel ? (
        <p className={`mb-1 fw-semibold ${feedback.className}`}>{feedback.strengthLabel}</p>
      ) : null}
      {feedback.stillNeededCaption ? (
        <p className={`mb-1 ${feedback.className}`}>{feedback.stillNeededCaption}</p>
      ) : null}
      {feedback.missingBullets.length > 0 ? (
        <ul className={`auth-flow-password-reqs mb-0 ps-3 ${feedback.className}`}>
          {feedback.missingBullets.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
